import type { FC } from 'react';
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import LockIcon from 'assets/images/lock.react.svg';
import { useIntl } from 'react-intl-next';
import { PaperContent } from 'view/layout/paper';
import { DocumentTitle } from '@atlassian/help-center-common-component/document-title';
import Redirect from '@atlassian/help-center-common-util/redirect';
import { getHelpCenterUrl } from '@atlassian/help-center-common-util/url';
import messages from './messages';
import { Message, Description, Container, IconContainer, AnchorContainer } from './styled';

interface Props {
    isUserLoggedIn: boolean;
    userEmail: string;
}

const PortalAccessForbidden: FC<Props> = ({ isUserLoggedIn, userEmail }) => {
    const callToActionUrl = 'https://start.atlassian.com/';
    const { formatMessage } = useIntl();

    if (!isUserLoggedIn) {
        return <Redirect to={getHelpCenterUrl()} />;
    }

    return (
        <DocumentTitle title={formatMessage(messages.documentTitle)}>
            <PaperContent>
                <Container>
                    <IconContainer>
                        <LockIcon />
                    </IconContainer>
                    <Message>{formatMessage(messages.errorHeading)}</Message>
                    <Description>
                        <FormattedHTMLMessage
                            {...messages.errorDescription}
                            values={{
                                userEmail,
                            }}
                        />
                    </Description>
                    <AnchorContainer actionSubjectId="redirectToAtlassianStart" href={callToActionUrl}>
                        {formatMessage(messages.callToActionText)}
                    </AnchorContainer>
                </Container>
            </PaperContent>
        </DocumentTitle>
    );
};

export default PortalAccessForbidden;
